module.exports = __webpack_public_path__ + "static/img/xe_rzs.9bd793b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xe_rzs.png
// module id = qNKo
// module chunks = 0